<template>
  <div class="ViewAboutBlocks">
    <div class="ViewAboutBlocks__row row">
      <div class="ViewAboutBlocks__col col-4 col-md-12">
        <div class="ViewAboutBlocks__block app-main-container">
          <div class="ViewAboutBlocks__block-title">
            Управляйте своими предложениями
          </div>
          <ul class="ViewAboutBlocks__list">
            <li class="ViewAboutBlocks__list-item">
              <img
                src="/icons/checked.svg"
                alt=""
                class="ViewAboutBlocks__list-icon"
              />Добавляйте новые товары
            </li>
            <li class="ViewAboutBlocks__list-item">
              <img
                src="/icons/checked.svg"
                alt=""
                class="ViewAboutBlocks__list-icon"
              />Управляйте ценами
            </li>
            <li class="ViewAboutBlocks__list-item">
              <img
                src="/icons/checked.svg"
                alt=""
                class="ViewAboutBlocks__list-icon"
              />Указывайте технические параметры
            </li>
            <li class="ViewAboutBlocks__list-item">
              <img
                src="/icons/checked.svg"
                alt=""
                class="ViewAboutBlocks__list-icon"
              />Управляйте параметрами логистики
            </li>
          </ul>
        </div>
      </div>

      <div class="ViewAboutBlocks__col col-4 col-md-12">
        <div class="ViewAboutBlocks__block app-main-container">
          <div class="ViewAboutBlocks__block-title">
            Управляйте продажами и сделками
          </div>
          <ul class="ViewAboutBlocks__list">
            <li class="ViewAboutBlocks__list-item">
              <img
                src="/icons/checked.svg"
                alt=""
                class="ViewAboutBlocks__list-icon"
              />Отслеживайте информацию по продажам
            </li>
            <li class="ViewAboutBlocks__list-item">
              <img
                src="/icons/checked.svg"
                alt=""
                class="ViewAboutBlocks__list-icon"
              />Управляйте всеми параметрами сделки
            </li>
            <li class="ViewAboutBlocks__list-item">
              <img
                src="/icons/checked.svg"
                alt=""
                class="ViewAboutBlocks__list-icon"
              />Автоматизируйте документооборот
            </li>
          </ul>
        </div>
      </div>

      <div class="ViewAboutBlocks__col col-4 col-md-12">
        <div class="ViewAboutBlocks__block app-main-container">
          <div class="ViewAboutBlocks__block-title">
            Анализируйте сводную статистику
          </div>
          <ul class="ViewAboutBlocks__list">
            <li class="ViewAboutBlocks__list-item">
              <img
                src="/icons/checked.svg"
                alt=""
                class="ViewAboutBlocks__list-icon"
              />Сегментация данных
            </li>
            <li class="ViewAboutBlocks__list-item">
              <img
                src="/icons/checked.svg"
                alt=""
                class="ViewAboutBlocks__list-icon"
              />Готовые отчеты
            </li>
            <li class="ViewAboutBlocks__list-item">
              <img
                src="/icons/checked.svg"
                alt=""
                class="ViewAboutBlocks__list-icon"
              />Анализ рынка
            </li>
            <li class="ViewAboutBlocks__list-item">
              <img
                src="/icons/checked.svg"
                alt=""
                class="ViewAboutBlocks__list-icon"
              />Big Data
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewAboutBlocks',
  components: {
    // AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  props: {},
};
</script>

<style lang="scss">
.ViewAboutBlocks {
  overflow: hidden;
  &__block {
    padding: 40px 35px;
    height: 100%;
    @include media-md {
      padding: 30px 25px;
    }
  }
  &__block-title {
    font-size: 24px;
    line-height: 1.2;
    font-weight: 700;
    margin-bottom: 25px;
    @include media-lg {
      font-size: rem(20);
    }
    @include media-sm {
      font-size: rem(18);
    }
  }
  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  &__col {
    @include media-md {
      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }
  &__list-item {
    position: relative;
    font-size: 17px;
    font-weight: 300;
    line-height: 1.2;
    padding-left: 40px;
    @include media-lg {
      font-size: rem(15);
    }
    &:not(:last-child) {
      margin-bottom: 17px;
    }
  }
  &__list-icon {
    width: 25px;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
